<app-my-listing [isEckardStaff]="true"></app-my-listing>